module.exports = __webpack_public_path__ + "static/img/企业互动@4x.2f6eb7d3.png";